import { User } from "./User";
import { ShiftStatus } from "../types/shiftStatus";
import { ShiftMode } from "../types/shiftMode";

type PlaceRef = {
  id?: string;
  name?: string;
};

export type Plantao = {
  id: string;
  status: ShiftStatus;
  mode: ShiftMode;
  total_slots: number;
  start_date_utc: Date;
  place_id?: PlaceRef | null;
  city_id?: PlaceRef | null;
  language_id: object | null;
  facilitator_user_id: User | null;
  shift_team_shift: EscalaPlantao[];
};

export type EscalaPlantao = {
  id: string;
  interviewer_user_id: User | null;
  assistant_user_id: User | null;
  start_date_utc: Date;
  end_date_utc: Date;
};

export function vagasAbertas(plantao: Plantao): number {
  let vagas = 0;
  if (!plantao.facilitator_user_id) {
    vagas += 1;
  }
  plantao.shift_team_shift.forEach((escala) => {
    if (!escala.interviewer_user_id) {
      vagas += 1;
    }
    if (!escala.assistant_user_id) {
      vagas += 1;
    }
  });

  return vagas;
}

export type MyShiftRole = "facilitador" | "entrevistador" | "assistente";

export type MyShiftFacilitator = {
  id: string;
  first_name: string;
  last_name: string;
};

export type MyShift = {
  id: string;
  shiftId: string;
  role: MyShiftRole;
  mode: string;
  place: string;
  startDate: Date;
  endDate?: Date;
  link?: string;
  facilitator?: MyShiftFacilitator | null;
};
